export const CHAT_FILE_ACCEPT =
  '.csv,.xlsx,.txt,.pdf,.PDF,image/png,image/jpeg,image/webp,image/gif';

export function isImageFile(file: Blob | null | undefined): boolean {
  return Boolean(file && file.type.startsWith('image/'));
}

/** Preview URL or data URL for a stored prompt image. */
export function imageSrcForPrompt(
  image?: string | null,
  fileType?: string | null,
): string | null {
  if (!image) return null;
  if (image.startsWith('blob:') || image.startsWith('data:')) return image;
  const raw = (fileType || 'png').toLowerCase();
  const mime = raw.startsWith('image/')
    ? raw
    : `image/${raw === 'jpg' ? 'jpeg' : raw}`;
  return `data:${mime};base64,${image}`;
}
